import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLocation } from '../store/slices/locationSlice';
import { userAddressesList, userSavedAddresses } from '../store/selectors/userAddresses';
import { t } from 'i18next';
import { useWelcomeDone } from './welcomeScreen';

const LOCATION_REQUESTED_KEY = 'location_requested';

export const useAskTelegramLocation = () => {
  const dispatch = useDispatch();
  const addresses = useSelector(userAddressesList);
  const selectedAddressId = useSelector(userSavedAddresses);
  // Окно «приложение хочет получить доступ к местоположению» — только после
  // приветственной заставки, а не поверх неё.
  const welcomeDone = useWelcomeDone();

  useEffect(() => {
    if (!welcomeDone) return;

    // Don't request location if user has a saved address selected
    if (selectedAddressId && addresses.length > 0) {
      const savedAddress = addresses.find(addr => addr._id === selectedAddressId);
      if (savedAddress) return;
    }

    // Don't request location if location was already set from saved address
    const storedLocation = sessionStorage.getItem('location');
    if (storedLocation) {
      try {
        const parsedLocation = JSON.parse(storedLocation);
        // If coordinates are not default values, assume they were set from saved address
        if (parsedLocation.latitude !== 0 && parsedLocation.longitude !== 0 && 
            parsedLocation.latitude !== 41.2995 && parsedLocation.longitude !== 69.2401) {
          return;
        }
      } catch (e) {
        // Continue if parsing fails
      }
    }

    const WebApp = window.Telegram.WebApp;
    const LM = WebApp.LocationManager;

    const alreadyRequested = sessionStorage.getItem(LOCATION_REQUESTED_KEY);
    if (alreadyRequested) return;

    sessionStorage.setItem(LOCATION_REQUESTED_KEY, 'true');

    const requestLocation = () => {
      if (!LM.isInited) {
        LM.init(() => runLogic());
      } else {
        runLogic();
      }
    };

    const runLogic = () => {
      if (LM.isAccessGranted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        LM.getLocation((location: { latitude: any; longitude: any }) => {
          if (location) {
            dispatch(
              setLocation({
                latitude: location.latitude,
                longitude: location.longitude,
              })
            );
          }
        });
        return;
      }

      WebApp.showConfirm(t('location-request'), (ok: boolean) => {
        if (!ok) return;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        LM.getLocation((location: { latitude: any; longitude: any }) => {
          if (location) {
            dispatch(
              setLocation({
                latitude: location.latitude,
                longitude: location.longitude,
              })
            );
          } else {
            WebApp.showAlert(t('location-error'));
          }
        });
      });
    };

    requestLocation();
  }, [dispatch, addresses, selectedAddressId, welcomeDone]);
};
